import { Link, useParams } from 'react-router-dom';
import { news } from '@/data/site';
import { ChevronRight } from 'lucide-react';
import { usePageContent } from '@/context/SiteDataContext';
import PageHero from '@/components/PageHero';

export function NewsList() {
  const c = usePageContent('news');
  return (
    <div>
      <PageHero slug="news" overline="Stay Informed" heading="News & Announcements" />
      <section className="bg-white py-20">
        <div className="max-w-7xl mx-auto px-6 grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {news.map(n => (
            <Link key={n.id} to={`/news/${n.id}`} data-testid={`news-item-${n.id}`} className="card-tactile overflow-hidden group">
              <div className="aspect-[16/10] overflow-hidden"><img src={n.image} alt={n.title} className="w-full h-full object-cover group-hover:scale-105 transition duration-500" /></div>
              <div className="p-6">
                <div className="text-xs text-gold uppercase tracking-widest font-semibold">{n.category}</div>
                <h3 className="font-serif text-xl text-royal font-bold mt-2 group-hover:text-gold transition">{n.title}</h3>
                <p className="text-charcoal-muted text-sm mt-2">{n.excerpt}</p>
                <div className="mt-4 text-sm text-royal flex items-center gap-1 font-semibold">Read more <ChevronRight className="w-4 h-4" /></div>
              </div>
            </Link>
          ))}
        </div>
      </section>
    </div>
  );
}

export function NewsDetail() {
  const { id } = useParams();
  const article = news.find(n => n.id === id);
  if (!article) return <div className="py-24 text-center">Article not found. <Link to="/news" className="text-royal underline">Back</Link></div>;
  return (
    <article className="bg-white py-20">
      <div className="max-w-3xl mx-auto px-6">
        <div className="overline mb-4">{article.category}</div>
        <h1 className="font-serif text-3xl lg:text-5xl text-royal font-bold leading-tight">{article.title}</h1>
        <div className="mt-4 text-sm text-charcoal-muted">By {article.author}</div>
        <img src={article.image} alt={article.title} className="w-full aspect-[16/9] object-cover rounded-xl my-10" />
        <p className="text-lg text-charcoal-muted leading-relaxed">{article.body}</p>
        <p className="text-lg text-charcoal-muted leading-relaxed mt-6">{article.excerpt}</p>
        <Link to="/news" className="mt-10 inline-block text-royal font-semibold hover:text-gold">← Back to News</Link>
      </div>
    </article>
  );
}
